/* src/app/private/components/reports/report-list/report-list.component.scss */
.reports-container {
  min-height: 100vh;
  background:
    linear-gradient(
      135deg,
      #f8fafc 0%,
      #e0f2fe 100%);
  padding: 2rem 1rem;
  font-family:
    "Inter",
    -apple-system,
    BlinkMacSystemFont,
    sans-serif;
}
.reports-container .header-section {
  text-align: center;
  margin-bottom: 3rem;
}
.reports-container .header-section .main-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1a202c;
  margin-bottom: 1rem;
  letter-spacing: -0.025em;
}
.reports-container .header-section .subtitle {
  font-size: 1.25rem;
  color: #718096;
  max-width: 48rem;
  margin: 0 auto;
  line-height: 1.6;
}
.reports-container .stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
  margin-bottom: 3rem;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}
.reports-container .stats-grid .stat-card {
  background: white;
  border-radius: 1rem;
  padding: 1.5rem;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  border: 1px solid #f7fafc;
  transition: all 0.3s ease;
}
.reports-container .stats-grid .stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 20px 40px -5px rgba(0, 0, 0, 0.15);
}
.reports-container .stats-grid .stat-card .stat-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.reports-container .stats-grid .stat-card .stat-content .stat-info .stat-label {
  color: #a0aec0;
  font-size: 0.875rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
}
.reports-container .stats-grid .stat-card .stat-content .stat-info .stat-value {
  color: #1a202c;
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
}
.reports-container .stats-grid .stat-card .stat-content .stat-icon {
  padding: 0.75rem;
  border-radius: 0.75rem;
}
.reports-container .stats-grid .stat-card .stat-content .stat-icon i {
  font-size: 2rem;
  color: white;
}
.reports-container .stats-grid .stat-card .stat-content .stat-icon.stat-icon-blue {
  background:
    linear-gradient(
      135deg,
      #3182ce,
      #2c5282);
}
.reports-container .stats-grid .stat-card .stat-content .stat-icon.stat-icon-emerald {
  background:
    linear-gradient(
      135deg,
      #38a169,
      #2f855a);
}
.reports-container .stats-grid .stat-card .stat-content .stat-icon.stat-icon-purple {
  background:
    linear-gradient(
      135deg,
      #805ad5,
      #6b46c1);
}
.reports-container .reports-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 2rem;
  max-width: 1400px;
  margin: 0 auto;
}
.reports-container .reports-grid .report-card {
  background: white;
  border-radius: 1.25rem;
  overflow: hidden;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  border: 1px solid #f7fafc;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  position: relative;
}
.reports-container .reports-grid .report-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
}
.reports-container .reports-grid .report-card:hover .card-title {
  color: #3182ce;
}
.reports-container .reports-grid .report-card:hover .card-icon {
  transform: scale(1.1);
}
.reports-container .reports-grid .report-card:hover .view-button {
  background:
    linear-gradient(
      135deg,
      #2b77cb,
      #1e40af);
}
.reports-container .reports-grid .report-card .card-header {
  padding: 1.5rem;
  padding-bottom: 1rem;
}
.reports-container .reports-grid .report-card .card-header .card-icon-wrapper {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 1rem;
}
.reports-container .reports-grid .report-card .card-header .card-icon-wrapper .card-icon {
  padding: 0.75rem;
  border-radius: 0.75rem;
  transition: all 0.3s ease;
}
.reports-container .reports-grid .report-card .card-header .card-icon-wrapper .card-icon i {
  font-size: 1.5rem;
  color: white;
}
.reports-container .reports-grid .report-card .card-header .card-icon-wrapper .card-icon.icon-emerald {
  background:
    linear-gradient(
      135deg,
      #10b981,
      #059669);
}
.reports-container .reports-grid .report-card .card-header .card-icon-wrapper .card-icon.icon-blue {
  background:
    linear-gradient(
      135deg,
      #3b82f6,
      #2563eb);
}
.reports-container .reports-grid .report-card .card-header .card-icon-wrapper .card-icon.icon-purple {
  background:
    linear-gradient(
      135deg,
      #8b5cf6,
      #7c3aed);
}
.reports-container .reports-grid .report-card .card-header .card-icon-wrapper .card-icon.icon-orange {
  background:
    linear-gradient(
      135deg,
      #f59e0b,
      #d97706);
}
.reports-container .reports-grid .report-card .card-header .card-icon-wrapper .card-icon.icon-indigo {
  background:
    linear-gradient(
      135deg,
      #6366f1,
      #4f46e5);
}
.reports-container .reports-grid .report-card .card-header .card-icon-wrapper .card-icon.icon-teal {
  background:
    linear-gradient(
      135deg,
      #14b8a6,
      #0d9488);
}
.reports-container .reports-grid .report-card .card-header .card-icon-wrapper .category-badge {
  padding: 0.25rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 600;
  border: 1px solid;
}
.reports-container .reports-grid .report-card .card-header .card-icon-wrapper .category-badge.category-emerald {
  background: #ecfdf5;
  color: #065f46;
  border-color: #a7f3d0;
}
.reports-container .reports-grid .report-card .card-header .card-icon-wrapper .category-badge.category-blue {
  background: #eff6ff;
  color: #1e40af;
  border-color: #93c5fd;
}
.reports-container .reports-grid .report-card .card-header .card-icon-wrapper .category-badge.category-purple {
  background: #f5f3ff;
  color: #5b21b6;
  border-color: #c4b5fd;
}
.reports-container .reports-grid .report-card .card-header .card-icon-wrapper .category-badge.category-orange {
  background: #fff7ed;
  color: #9a3412;
  border-color: #fed7aa;
}
.reports-container .reports-grid .report-card .card-header .card-icon-wrapper .category-badge.category-indigo {
  background: #eef2ff;
  color: #3730a3;
  border-color: #a5b4fc;
}
.reports-container .reports-grid .report-card .card-header .card-icon-wrapper .category-badge.category-teal {
  background: #f0fdfa;
  color: #134e4a;
  border-color: #99f6e4;
}
.reports-container .reports-grid .report-card .card-header .card-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1a202c;
  margin-bottom: 0.75rem;
  line-height: 1.4;
  transition: color 0.3s ease;
}
.reports-container .reports-grid .report-card .card-header .card-description {
  color: #718096;
  font-size: 0.875rem;
  line-height: 1.6;
  margin: 0;
}
.reports-container .reports-grid .report-card .card-footer {
  padding: 1rem 1.5rem;
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.reports-container .reports-grid .report-card .card-footer .last-updated {
  display: flex;
  align-items: center;
  color: #a0aec0;
  font-size: 0.75rem;
}
.reports-container .reports-grid .report-card .card-footer .last-updated i {
  font-size: 1rem;
  margin-right: 0.25rem;
}
.reports-container .reports-grid .report-card .card-footer .view-button {
  display: inline-flex;
  align-items: center;
  padding: 0.5rem 1rem;
  background:
    linear-gradient(
      135deg,
      #3182ce,
      #2c5282);
  color: white;
  text-decoration: none;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  transition: all 0.2s ease;
}
.reports-container .reports-grid .report-card .card-footer .view-button span {
  margin-right: 0.5rem;
}
.reports-container .reports-grid .report-card .card-footer .view-button i {
  font-size: 1rem;
}
.reports-container .reports-grid .report-card .card-footer .view-button:hover {
  background:
    linear-gradient(
      135deg,
      #2b77cb,
      #1e40af);
}
.reports-container .load-more-section {
  text-align: center;
  margin-top: 3rem;
}
.reports-container .load-more-section .load-more-btn {
  display: inline-flex;
  align-items: center;
  padding: 0.75rem 2rem;
  background:
    linear-gradient(
      135deg,
      #3182ce,
      #805ad5);
  color: white;
  border: none;
  border-radius: 0.75rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 10px 25px -5px rgba(49, 130, 206, 0.4);
  transition: all 0.2s ease;
}
.reports-container .load-more-section .load-more-btn:hover {
  transform: scale(1.05);
  box-shadow: 0 20px 40px -5px rgba(49, 130, 206, 0.6);
  background:
    linear-gradient(
      135deg,
      #2b77cb,
      #7c3aed);
}
.reports-container .load-more-section .load-more-btn span {
  margin-right: 0.5rem;
}
.reports-container .load-more-section .load-more-btn i {
  font-size: 1.25rem;
}
@media (max-width: 768px) {
  .reports-container {
    padding: 1rem;
  }
  .reports-container .header-section .main-title {
    font-size: 2rem;
  }
  .reports-container .header-section .subtitle {
    font-size: 1.125rem;
  }
  .reports-container .stats-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  .reports-container .reports-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
}
@media (max-width: 480px) {
  .reports-container .header-section .main-title {
    font-size: 1.75rem;
  }
  .reports-container .stat-card .stat-content .stat-info .stat-value {
    font-size: 1.75rem;
  }
  .reports-container .report-card .card-header {
    padding: 1rem;
  }
  .reports-container .report-card .card-footer {
    padding: 0.75rem 1rem;
    flex-direction: column;
    gap: 0.75rem;
    align-items: stretch;
  }
  .reports-container .report-card .card-footer .view-button {
    justify-content: center;
  }
}
/*# sourceMappingURL=report-list.component.css.map */
